import SpellsTablet from "./SpellsTablet";

export default SpellsTablet;
export { SpellsTablet };
